/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


import * as i0 from '@angular/core';
import * as i1 from '@angular/common';
import * as i2 from '../../../app/components/modal';
import * as i3 from '../../../app/services/modal';
const styles_ModalComponent:any[] = ([] as any[]);
export const RenderType_ModalComponent:i0.RendererType2 = i0.ɵcrt({encapsulation:2,
    styles:styles_ModalComponent,data:{}});
export function View_ModalComponent_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[i0.ɵqud(402653184,1,{placeholderVcr:0}),(_l()(),i0.ɵted(-1,(null as any),
      ['\n    '])),(_l()(),i0.ɵeld(2,0,(null as any),(null as any),16,'div',[['class',
      'modal']],(null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n      '])),(_l()(),i0.ɵeld(4,0,(null as any),
          (null as any),13,'div',[['class','m__content-wrapper']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),i0.ɵdid(5,278528,(null as any),
          0,i1.NgClass,[i0.IterableDiffers,i0.KeyValueDiffers,i0.ElementRef,i0.Renderer],
          {klass:[0,'klass'],ngClass:[1,'ngClass']},(null as any)),i0.ɵpod(6,{'is-visible':0}),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵeld(8,0,(null as any),
          (null as any),0,'div',[['class','m__white-wash']],(null as any),(null as any),
          (null as any),(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),
          ['\n        '])),(_l()(),i0.ɵeld(10,0,(null as any),(null as any),6,'div',
          [['class','m__modal']],(null as any),(null as any),(null as any),(null as any),
          (null as any))),(_l()(),i0.ɵted(-1,(null as any),['\n          '])),(_l()(),
          i0.ɵeld(12,16777216,[[1,3],['placeholder',1]],(null as any),0,'div',([] as any[]),
              (null as any),(null as any),(null as any),(null as any),(null as any))),
      (_l()(),i0.ɵted(-1,(null as any),['\n          '])),(_l()(),i0.ɵeld(14,0,(null as any),
          (null as any),1,'div',[['class','m__close']],(null as any),[[(null as any),
              'click']],(_v,en,$event) => {
            var ad:boolean = true;
            var _co:i2.ModalComponent = _v.component;
            if (('click' === en)) {
              const pd_0:any = ((<any>_co.closeModal()) !== false);
              ad = (pd_0 && ad);
            }
            return ad;
          },(null as any),(null as any))),(_l()(),i0.ɵted(-1,(null as any),['×'])),
      (_l()(),i0.ɵted(-1,(null as any),['\n        '])),(_l()(),i0.ɵted(-1,(null as any),
          ['\n      '])),(_l()(),i0.ɵted(-1,(null as any),['\n    '])),(_l()(),i0.ɵted(-1,
          (null as any),['\n  ']))],(_ck,_v) => {
    var _co:i2.ModalComponent = _v.component;
    const currVal_0:any = 'm__content-wrapper';
    const currVal_1:any = _ck(_v,6,0,_co.isVisible);
    _ck(_v,5,0,currVal_0,currVal_1);
  },(null as any));
}
export function View_ModalComponent_Host_0(_l:any):i0.ɵViewDefinition {
  return i0.ɵvid(0,[(_l()(),i0.ɵeld(0,0,(null as any),(null as any),1,'modal',([] as any[]),
      (null as any),(null as any),(null as any),View_ModalComponent_0,RenderType_ModalComponent)),
      i0.ɵdid(1,114688,(null as any),0,i2.ModalComponent,[i3.ModalService,i0.ComponentFactoryResolver],
          (null as any),(null as any))],(_ck,_v) => {
    _ck(_v,1,0);
  },(null as any));
}
export const ModalComponentNgFactory:i0.ComponentFactory<i2.ModalComponent> = i0.ɵccf('modal',
    i2.ModalComponent,View_ModalComponent_Host_0,{},{},([] as any[]));
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tb2RhbC5uZ2ZhY3RvcnkudHMiLCJ2ZXJzaW9uIjozLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWwudHMiLCJuZzovLy9Vc2Vycy9qYXNvbi9zcmMvbWF0cml4L2NsaWVudC9zcmMvYXBwL2NvbXBvbmVudHMvbW9kYWwudHMuTW9kYWxDb21wb25lbnQuaHRtbCIsIm5nOi8vL1VzZXJzL2phc29uL3NyYy9tYXRyaXgvY2xpZW50L3NyYy9hcHAvY29tcG9uZW50cy9tb2RhbC50cy5Nb2RhbENvbXBvbmVudF9Ib3N0Lmh0bWwiXSwic291cmNlc0NvbnRlbnQiOlsiICIsIlxuICAgIDxkaXYgY2xhc3M9XCJtb2RhbFwiPlxuICAgICAgPGRpdiBjbGFzcz1cIm1fX2NvbnRlbnQtd3JhcHBlclwiIFtuZ0NsYXNzXT1cInsgJ2lzLXZpc2libGUnOiBpc1Zpc2libGUgfVwiPlxuICAgICAgICA8ZGl2IGNsYXNzPVwibV9fd2hpdGUtd2FzaFwiPjwvZGl2PlxuICAgICAgICA8ZGl2IGNsYXNzPVwibV9fbW9kYWxcIj5cbiAgICAgICAgICA8ZGl2ICNwbGFjZWhvbGRlcj48L2Rpdj5cbiAgICAgICAgICA8ZGl2IGNsYXNzPVwibV9fY2xvc2VcIiAoY2xpY2spPVwiY2xvc2VNb2RhbCgpXCI+JnRpbWVzOzwvZGl2PlxuICAgICAgICA8L2Rpdj5cbiAgICAgIDwvZGl2PlxuICAgIDwvZGl2PlxuICAiLCI8bW9kYWw+PC9tb2RhbD4iXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7Ozs7Ozs7Ozs7OzREQ0FBO01BQUEsYUFDSTtNQUFBO01BQW1CLGdEQUNqQjtVQUFBO1VBQUEsbURBQUE7VUFBQTtVQUFBLGdFQUFnQztNQUF3QyxrREFDdEU7VUFBQTtVQUFBLDRDQUFpQztVQUFBLGlCQUNqQztVQUFBO1VBQUEsZ0JBQXNCLG9EQUNwQjtpQkFBQTtjQUFBO01BQXdCLG9EQUN4QjtVQUFBO2NBQUE7WUFBQTtZQUFBO1lBQXNCO2NBQUE7Y0FBQTtZQUFBO1lBQXRCO1VBQUEsZ0NBQTZDO01BQWEsa0RBQ3REO1VBQUEsZUFDRiw4Q0FDRjtVQUFBOztJQVBDO0lBQTJCO0lBQWhDLFdBQUssVUFBMkIsU0FBaEM7Ozs7b0JDRk47TUFBQTthQUFBO1VBQUE7SUFBQTs7OzsifQ==



// WEBPACK FOOTER //
// /Users/jason/src/matrix/client/src/$$_gendir/app/components/modal.ngfactory.ts